import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/authentication/services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(public authService: AuthService, private router: Router) { }

  canActivate(route: any, state: RouterStateSnapshot) {
    let token = this.authService.getToken();
    // let sessionId = Cookies.get("sso_session");

    let orgSelectId = this.authService.getId();

    if (token && orgSelectId) {
      // Both token and orgSelectId are present, allow access to the route
      return true;
    }
    else if (token && !orgSelectId) {
      console.log('Organization ID missing, redirecting...');

      // this.authService.removeToken();

      // SSO
      let id;
      const baseUrl = window.location.origin;

      if (!localStorage.getItem('CSRF')) {
        id = crypto.randomUUID();
        localStorage.setItem('CSRF', id);
      }
      else {
        id = localStorage.getItem('CSRF');
      }

      console.log(state);


      if (!state.url.includes('/auth/callback')) {
        // window.location.href = environment.ssoUrl + 'sso/authorize?client_id=cb-sales&redirect_uri=' + baseUrl + '/auth/callback&state=' + id + '&prompt=none';
      }

      this.router.navigateByUrl('/select-company', { replaceUrl: true });

      return false;
    }
    else {
      // Token is missing — check if this is an invite callback before redirecting.
      // Invite flows arrive at /auth/callback with state=invite_<token>.
      // Let non-ui-auth handle CSRF validation; the invite_ prefix is the trust signal.
      const urlParams = new URLSearchParams(window.location.search);
      const incomingState = urlParams.get('state') || '';
      if (state.url.includes('/auth/callback') && incomingState.startsWith('invite_')) {
        console.log('Invite flow detected — bypassing auth guard CSRF check.');
        return true;
      }

      // Standard flow: no token, redirect to login page
      console.log('No token found, redirecting to login...');

      this.authService.removeId();
      this.authService.removeToken();
      localStorage.removeItem('CSRF');
      // SSO
      let id;
      const baseUrl = window.location.origin;

      if (!localStorage.getItem('CSRF')) {
        id = crypto.randomUUID();
        localStorage.setItem('CSRF', id);
      }
      else {
        id = localStorage.getItem('CSRF');
      }

      if (!state.url.includes('/auth/callback')) {
        window.location.href = environment.ssoApiUrl + 'sso/authorize?client_id=cb-sales&redirect_uri=' + baseUrl + '/auth/callback&state=' + id + '&prompt=none';
      }

      // this.router.navigateByUrl('/login', { replaceUrl: true });
      return false;
    }

  }
}
